import { Divider, Drawer as MuiDrawer, styled } from '@mui/material'
import { usePrivateLayoutDrawerContext } from 'src/context/PrivateLayoutDrawerContext'
import SideBarRouteList from './components/SideBarRouteList'

export const drawerWidth = 300
export const drawerWidthPx = '300px'
export const drawerCloseWidth = 70
export const drawerCloseWidthPx = '70px'

const Drawer = styled(MuiDrawer)(({ theme }) => ({
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  '&.open': {
    width: drawerWidthPx,
    '& .MuiDrawer-paper': {
      width: drawerWidthPx,
      boxSizing: 'border-box',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      })
    }
  },
  '&.close': {
    width: drawerCloseWidthPx,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    '& .MuiDrawer-paper': {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
      }),
      width: drawerCloseWidthPx
    }
  },
  [theme.breakpoints.down('sm')]: {
    position: 'absolute',
    '&.open': {
      width: '100%',
      '& .MuiDrawer-paper': {
        width: '100%',
        top: '67px',
        paddingTop: '10px'
      }
    },
    '&.close': {
      width: '0',
      '& .MuiDrawer-paper': {
        width: '0',
        top: '67px',
        paddingTop: '10px',
        marginLeft: -drawerCloseWidth
      }
    }
  }
}))

export default function PrivateLayoutDrawer(): JSX.Element {
  const { theme, open, privateDrawerChildren } = usePrivateLayoutDrawerContext()

  return (
    <>
      <Drawer
        variant="permanent"
        className={open ? 'open' : 'close'}
        sx={{
          '& .MuiDrawer-paper': {
            bgcolor: theme.colors.navyBlack,
            border: 'none',
            color: 'white',
            borderRadius: '0px 0px 0px 0px',
            // zIndex: 1500,
            overflow: 'visible'
          },
          '& .MuiBox-root::-webkit-scrollbar-track': {
            borderRadius: '10px',
            backgroundColor: theme.colors.navyBlack
          },
          '& .MuiBox-root::-webkit-scrollbar': {
            borderRadius: '4px',
            width: open ? '7px' : '4px',
            backgroundColor: theme.colors.navyBlack
          },
          '& .MuiBox-root::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: '#2F4A5A'
          },
          bgcolor: theme.colors.background
        }}>
        {privateDrawerChildren ? (
          privateDrawerChildren
        ) : (
          <>
            <SideBarRouteList isSidebarOpen={open} />
            <Divider />
          </>
        )}
      </Drawer>
    </>
  )
}
